var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"impersona"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"90","color":"#2536cc"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }